import { createSelector } from 'reselect';

import { businessShoppingCenterSelector } from './businessShoppingCenterSelector';

export const selectBusinessShoppingCenterParkings = createSelector(businessShoppingCenterSelector, bsc => {
  if (bsc && bsc.parkings) {
    return bsc.parkings;
  }

  return null;
});
